import { render, staticRenderFns } from "./settings-body.vue?vue&type=template&id=571f026c"
import script from "./settings-body.vue?vue&type=script&lang=js"
export * from "./settings-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports